<template>
  <v-container class="signin pb-16" fill-height>
    <v-row class="m-auto">
      <v-col cols="12" class="mt-3 mb-3">
        <h2 class="text-h4">Авторизація</h2>
      </v-col>
      <v-col cols="12">
        <v-form @submit.prevent="submit">
          <v-row no-gutters>
            <v-col cols="12" class="mb-5">
              <v-text-field
                v-model="pin"
                label="PIN-код"
                type="password"
                inputmode="numeric"
                maxlength="6"
                pattern="[0-9]{6}"
                autocomplete="off"
                outlined
                hide-details="auto"
                class="is-required"
                :disabled="isBeingSubmitted"
                :error-messages="pinErrors"
                @input="onPinInput"
                @blur="$v.pin.$touch()" />
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                type="submit"
                dark
                depressed
                x-large
                :disabled="isBeingSubmitted"
                :loading="isBeingSubmitted">
                Увійти
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-btn text color="primary" :to="{ name: 'Home' }">
          Переглянути карту без авторизації
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="snack" :timeout="5000" color="error">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="snack = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { LOGIN_REQUEST } from '@/store/auth/types';

export default {
  data: () => ({
    pin: '',
    serverPinErrors: [],
    isBeingSubmitted: false,
    snack: false,
    snackText: '',
  }),
  computed: {
    pinErrors() {
      const errors = [...this.serverPinErrors];
      if (!this.$v.pin.$dirty) return errors;
      if (!this.$v.pin.required) errors.push("Вкажіть PIN-код.");
      else if (!this.$v.pin.sixDigits) errors.push('PIN-код має містити рівно 6 цифр.');
      return errors;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    onPinInput() {
      this.serverPinErrors = [];
      this.snack = false;
      this.$v.pin.$touch();
    },
    async submit() {
      if (this.isBeingSubmitted) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.isBeingSubmitted = true;
      this.serverPinErrors = [];
      this.snack = false;
      try {
        await this.$store.dispatch(LOGIN_REQUEST, { pin: this.pin });
        this.pin = '';
        this.$v.$reset();
        await this.$router.replace({ name: 'Home' });
      } catch (error) {
        const response = error && error.response;
        const fieldErrors = response && response.status === 422 && response.data && response.data.errors;
        if (fieldErrors && fieldErrors.pin) {
          this.serverPinErrors = Array.isArray(fieldErrors.pin) ? fieldErrors.pin : [fieldErrors.pin];
        } else {
          this.snack = true;
          this.snackText = response && response.status === 401 ? 'Невірний PIN-код'
            : response && response.status === 429 ? 'Забагато спроб. Спробуйте пізніше.'
              : 'Не вдалося увійти. Спробуйте ще раз.';
        }
      } finally {
        this.isBeingSubmitted = false;
      }
    },
  },
  validations: {
    pin: {
      required,
      sixDigits: (value) => /^[0-9]{6}$/.test(value),
    },
  },
  created() {
    if (this.isAuthenticated) this.$router.replace({ name: 'Home' }).catch(() => {});
  },
  beforeDestroy() {
    this.pin = '';
    this.serverPinErrors = [];
  },
};
</script>

<style lang="scss" scoped>
.signin {
  max-width: 350px;
}
[type="submit"] {
  width: 100%;
}
</style>
